import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  private subject = new Subject<any>();
  private keepAfterRouteChange = false;
  constructor(private http: HttpClient,private router: Router) {

    }

    getAlert(): Observable<any> {
        return this.subject.asObservable();
    }

    success(message: string, keepAfterRouteChange = false) {
        this.keepAfterRouteChange = keepAfterRouteChange;
        this.subject.next({ type: 'success', text: message });
    }

    error(message: string) {
          this.subject.next({ type: 'error', text: message });
    }


    googleMapError(linkposition,heading,fov,pitch)
    {
     //return this.http.get<any>(`https://stats.simuleo.com/counters/`);
     return this.http.get<any>(`https://maps.googleapis.com/maps/api/streetview/metadata?size=640x360&location=`+linkposition+`&heading=`+heading+`&fov=`+fov+`&pitch=`+pitch);

    }

    clear() {

        this.subject.next();
    }

}
